<template>
  <IndicatorCard
    :loading="loading"
    :has-data="ratings.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhum dado encontrado')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >
    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <strong class="pa-2">
            {{ $t('Qtd de Avaliações') }}: {{ total }}</strong
          >

          <div class="d-flex">
            <strong class="pa-2 error--text">
              {{ $t('Ruim') }}: {{ ratingCounts.bad }}
            </strong>
            <strong class="pa-2" style="color: rgb(239, 214, 19)">
              {{ $t('Regular') }}:
              {{ ratingCounts.regular }}
            </strong>
            <strong class="pa-2 secondary--text">
              {{ $t('Bom') }}: {{ ratingCounts.well }}
            </strong>
            <strong class="pa-2 primary--text">
              {{ $t('Ótima') }}:
              {{ ratingCounts.high }}
            </strong>
          </div>

          <div>
            <div class="hidden-md-and-up">
              <v-data-table
                :loading="loading"
                :headers="mobileHeader"
                :items="ratings"
                class="main-table my-2"
                :hide-default-footer="!filterProp.data"
                show-expand
                :single-expand="false"
                :items-per-page="7"
                :header-props="headerProps"
                :mobile-breakpoint="330"
                :expanded.sync="expanded"
                @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
              >
                <template #header="{ props, on }">
                  <thead>
                    <tr>
                      <th
                        class="text-center"
                        v-for="header in props.headers"
                        :key="header.value"
                      >
                        <v-simple-checkbox
                          v-if="header.value === 'data-table-select'"
                          v-model="props.everyItem"
                          :indeterminate="props.someItems && !props.everyItem"
                          color="purple"
                          @input="on['toggle-select-all']"
                        ></v-simple-checkbox>

                        <div>
                          <v-hover v-slot="{ hover }">
                            <div>
                              <span>{{ $t(header.text) }}</span>
                              <v-icon
                                v-if="
                                  hover &&
                                  header.value != 'data-table-select' &&
                                  header.value != 'actions'
                                "
                                color="white"
                                class="mx-2"
                                @click="on.sort(header.value)"
                              >
                                {{
                                  props.options.sortBy.includes(header.value)
                                    ? `mdi-chevron-down`
                                    : `mdi-chevron-up`
                                }}
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>

                <template v-slot:[`item.serviceOrder`]="{ item }">
                  {{ item.numeroOrdemServico }}
                </template>

                <template v-slot:[`item.rateRanking`]="{ item }">
                  {{ $t(item.avaliaRanking) }}
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Setor') }}:</strong>
                        {{ item.nomeDepartamento }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Observação') }}:</strong>
                        {{ item.avaliaObservacao }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('E-mail') }}:</strong>
                        {{ item.avaliaEmail }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Solicitante') }}:</strong>
                        {{ item.solicitante }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Data Fechamento O.S.') }}:</strong>
                        {{ formatDate(item.dataHoraFechamentoOs) }}
                      </p>
                    </v-col>
                  </td>
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="9"
                  ></v-pagination>
                </div>
              </div>
            </div>

            <div class="hidden-md-and-down">
              <v-data-table
                :loading="loading"
                :headers="header"
                :items="ratings"
                class="main-table my-2"
                :hide-default-footer="!filterProp.data"
                hide-default-header
                :header-props="headerProps"
                :items-per-page="7"
                :mobile-breakpoint="0"
              >
                <template #header="{ props, on }">
                  <thead>
                    <tr>
                      <th
                        class="text-center"
                        v-for="header in props.headers"
                        :key="header.value"
                      >
                        <v-simple-checkbox
                          v-if="header.value === 'data-table-select'"
                          v-model="props.everyItem"
                          :indeterminate="props.someItems && !props.everyItem"
                          color="purple"
                          @input="on['toggle-select-all']"
                        ></v-simple-checkbox>

                        <div>
                          <v-hover v-slot="{ hover }">
                            <div>
                              <span>{{ $t(header.text) }}</span>
                              <v-icon
                                v-if="
                                  hover &&
                                  header.value != 'data-table-select' &&
                                  header.value != 'actions'
                                "
                                color="white"
                                class="mx-2"
                                @click="on.sort(header.value)"
                              >
                                {{
                                  props.options.sortBy.includes(header.value)
                                    ? `mdi-chevron-down`
                                    : `mdi-chevron-up`
                                }}
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>

                <template v-slot:[`item.serviceOrder`]="{ item }">
                  {{ item.numeroOrdemServico }}
                </template>

                <template v-slot:[`item.department`]="{ item }">
                  {{ item.nomeDepartamento }}
                </template>

                <template v-slot:[`item.rateRanking`]="{ item }">
                  {{ $t(item.avaliaRanking) }}
                </template>

                <template v-slot:[`item.rateObs`]="{ item }">
                  {{ item.avaliaObservacao }}
                </template>

                <template v-slot:[`item.email`]="{ item }">
                  {{ item.avaliaEmail }}
                </template>

                <template v-slot:[`item.requester`]="{ item }">
                  {{ item.solicitante }}
                </template>

                <template v-slot:[`item.closeDate`]="{ item }">
                  {{ formatDate(item.dataHoraFechamentoOs) }}
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="9"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

    <template #review>
    

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult && review">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else-if="!isResult">
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import { getIndicatorById } from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import Utils from '../../../../../../../../Utils/FormatDate'
import moment from 'moment'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  data() {
    return {
      excelLoading: false,
      startDate: '',
      endDate: '',
      ratingCounts: {},
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      apiService: new ApiService(),
      loading: true,
      showChart: true,
      ratings: [],
      expanded: [],
      page: 1,
      total: 0,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nº Chamado',
          align: 'center',
          value: 'numeroChamado',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department',
        },
        {
          text: 'Avaliação',
          align: 'center',
          value: 'rateRanking',
        },
        {
          text: 'Observação',
          align: 'center',
          value: 'rateObs',
        },
        {
          text: 'E-mail',
          align: 'center',
          value: 'email',
        },
        {
          text: 'Solicitante',
          align: 'center',
          value: 'requester',
        },
        {
          text: 'Responsável',
          align: 'center',
          value: 'responsavel',
        },
        {
          text: 'Data Fechamento O.S.',
          align: 'center',
          value: 'closeDate',
        },
      ],
      mobileHeader: [
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'Avaliação',
          align: 'center',
          value: 'rateRanking',
        },
      ],
    }
  },
  computed: {
    indicator() {
      return getIndicatorById('order_ratings') || {}
    },
  },


  methods: {
    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.filter.page = 1
      this.page = 1
      this.filterProp.data = null
      this.list()
    },

    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${this.indicator.legacyKey}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, { ...this.filter, pageSize: 999999 })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: getIndicatorById('order_ratings').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },
    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.total = response.content.paginated.pager.totalItems
        this.totalPages = response.content.paginated.pager.totalPages
        this.showChart = response.content.paginated.objects.length > 0
        this.ratings = response.content.paginated.objects
        this.ratingCounts = {
        high: response.content.highRating,
        well: response.content.wellRating,
        regular: response.content.regularRating,
        bad: response.content.badRating,
        }
        return
        }

        if (!this.isResult) this.setDates()
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.unidadeIds = this.unidades
        const response = await this.apiService.post(
        this.apiEndpointOverride || 'reports/ratingServiceOrder', this.filter
        )
        this.total = response.content.paginated.pager.totalItems
        this.totalPages = response.content.paginated.pager.totalPages
        this.showChart = response.content.paginated.objects.length > 0
        this.ratings = response.content.paginated.objects
        this.ratingCounts = {
        high: response.content.highRating,
        well: response.content.wellRating,
        regular: response.content.regularRating,
        bad: response.content.badRating,
        }
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
